import type { CSSProperties } from "react";
import type { ThemeColors } from "src/mock/colorTheme";

export function buildGeneratorThemeVars(
  colors: ThemeColors,
): CSSProperties & Record<string, string | undefined> {
  return {
    "--gen-label-color": colors.main?.[9],
    "--gen-label-solid-bg": colors.thBackgroundColor?.[0],
    "--gen-label-solid-color": colors.thColor?.[0],
    "--gen-unit-solid-bg": colors.grayscale?.[3],
    "--gen-input-border": colors.inputBorder?.[0],
    "--gen-input-bg": colors.inputBackgroud?.[0],
    "--gen-input-focus-bg": colors.inputBackgroud?.[0],
    "--gen-input-readonly-bg": colors.inputBg?.[0],
    "--gen-text-muted": colors.grayText?.[0],
    "--gen-text-faint": colors.grayscale?.[0],
    "--gen-item-border": colors.thBorder?.[0],
    "--gen-item-bg": colors.tdBackgroundColor?.[0],
    "--gen-group-border": colors.grayscale?.[1],
    "--gen-panel-text": colors.panelText?.[0],
    "--gen-panel-hover-bg": colors.panelHover?.[0],
    "--gen-panel-text-active": colors.panelTextActive?.[0],
    "--gen-link-color": colors.main?.[6],
    "--gen-link-hover": colors.main?.[7],
    color: colors.text?.[0],
  };
}
